export default __webpack_public_path__ + "static/media/ExcelIcon.8d1d4eae.svg";